import React from 'react'


class TabsContents extends React.Component {
    render() {

        const ConvertContent = ({ conteudo }) => {
            return <React.Fragment>{conteudo}</React.Fragment>
        }

        return (

            <>
                {
                    this.props.contents.map((item, key) => {
                        return (

                            <div
                                className={`tab-pane ${item.active === true ? 'active' : ''}`}
                                id={`item${key}`}
                            >
                                <ConvertContent conteudo={item.conteudo} />
                            </div>

                        )
                    })
                }
            </>

        )
    }
}

export default TabsContents;
